<section class="toast-component-wrapper">
  <div class="toast-container" role="region" aria-label="Notifications">
    <div
      *ngFor="let toast of toasts"
      class="toast"
      [ngClass]="toast.type"
      role="alert"
      aria-live="assertive"
      (mouseenter)="pauseTimer(toast.id)"
      (mouseleave)="resumeTimer(toast)"
    >
      <div class="tag">{{ toast.type }}</div>

      <div class="content">{{ toast.message }}</div>

      <button
        *ngIf="toast.options.closable"
        class="close-btn"
        aria-label="Close notification"
        (click)="close(toast.id)"
      >
        ✕
      </button>
    </div>
  </div>
</section>
